import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import attributeMixin from 'dashboard/mixins/attributeMixin';

export default {
  mixins: [alertMixin, attributeMixin],
  data() {
    return {
      showAddCustomFieldsModal: false,
    };
  },
  computed: {
    ...mapGetters({
      currentChat: 'getSelectedChat',
    }),
    conversationId() {
      return this.currentChat.id;
    },
  },
  methods: {
    openAddCustomFieldModal() {
      this.$emit('openModal');
      this.showAddCustomFieldsModal = true;
    },
    closeAddCustomFieldModal() {
      this.$emit('closeModal');
      this.showAddCustomFieldsModal = false;
    },
  },
};
